export const VERSION = '29/06/2025 [09:15]';